export { default } from './Button';



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js